import styled from "styled-components";

const CardContainer = styled.div`
  border-radius: 1.2rem;
  background-color: white;
  padding: 2.4rem;
  margin: 2.4rem;
  width: 80vw;
  max-width: 32rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 1.2rem 2.4rem 0 rgba(0, 0, 0, 0.06);
`;

const Card = ({ children }) => {
  return <CardContainer>{children}</CardContainer>;
};

export default Card;
